<template>
  <div id="faq">
    <v-container class="pa-0">
      <v-layout>
        <v-flex class="xs12 sm12 mb-5">
          <v-btn v-if="editIndex === -1" fab absolute right class="mr-3 pf-btn-fab" to="/admin/faq/add">
            <v-icon>add</v-icon>
          </v-btn>
          <v-btn v-else fab absolute left @click="backTolisting" class="ml-3 pf-btn-fab">
            <v-icon>arrow_back</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-container>
    <v-container v-if="FAQList.length == 0" class="text-center">
        <img src="static/NoBlogs.jpg" class="noItemsTemplate">
        <h4 class="pf-text-green"><b>No FAQ Found !! </b></h4>
    </v-container>
    <v-container fluid class="pt-0 pl-0" v-if="editIndex === -1 && FAQList.length > 0">
      <v-container class="-border" v-for="(eachItem, key) of FAQList" :key="eachItem.id">
        <v-layout>
          <v-flex class="xs12 sm10">
            <h5 class="pf-sub-head mb-2 custom-title">
              <b>{{ (key + 1) + '. ' + eachItem.title }}</b>
            </h5>
            <p class="mb-0"><i>Category: {{ eachItem.category }} </i></p>
            <p class="mb-0"><i>Membership: {{ eachItem.membership.join(', ') }} </i></p>
          </v-flex>
          <v-flex class="xs12 sm2 text-md-right">
            <v-btn icon class="ma-0" @click="editItem(eachItem)">
              <v-icon size="22" color="grey darken-2">edit</v-icon>
            </v-btn>
            <v-btn icon class="ma-0">
              <v-icon v-on:click="deleteItem(eachItem)" size="22" color="grey darken-2">delete_outline</v-icon>
            </v-btn>
          </v-flex>
        </v-layout>
        <v-layout>
          <v-flex v-html="eachItem.description" class="text-xs-justify pt-3"></v-flex>
        </v-layout>
        <v-divider class="mt-4"></v-divider>
      </v-container>
    </v-container>
    <v-form v-if="editIndex != -1" ref="formEdit">
      <v-container class="-border" >
        <v-layout wrap>
          <v-flex xs12 class="button-container pr-3 text-xs-right">
            <div class="d-inline-flex" v-if="selectedData">
              <v-btn class="pf-btn pf-btn-cancel" @click="selectedData = false">
                <v-icon size="16" class="pr-1">cancel</v-icon>
                <div>Cancel</div>
              </v-btn>
              <v-btn class="pf-btn pf-btn-save" @click="save">
                <v-icon size="16" class="pr-1">check_circle</v-icon>
                <div>Save</div>
              </v-btn>
            </div>
          </v-flex>
        </v-layout>
        <v-layout>
            <v-flex class="xs12 sm6 md7">
              <v-select @change="changedData" @input="changedData" :items="categoryList" v-model="editData.category" label="Category" class="required pr-4 pl-4" required></v-select>
            </v-flex>
        </v-layout>
        <v-layout>
            <v-flex class="xs12 sm6 md7">
              <v-select @change="changedData" small-chips deletable-chips multiple :rules="membershipRules" :items="membershipList" v-model="editData.membership" label="Membership" class="required pr-4 pl-4" required></v-select>
            </v-flex>
        </v-layout>
        <v-layout>
          <v-flex class="xs12 sm12 md12">
            <v-text-field label="Question" v-model.trim="editData.title"
                          class="required pr-4 pl-4"
                          :rules="[rules.required]"
                          @input="changedData"></v-text-field>
          </v-flex>
        </v-layout>
        <v-layout>
          <v-flex>
            <div id="pageEditor" >
              <v-container grid-list-xl fluid>
                <v-layout row wrap>
                  <v-flex sm12>
                    <ejs-richtexteditor :height="ejsHeight" :rules="formRules.title" @input="changedData" :content="content" @change="changedData" ref="rteObj" placeholder="Add description here.." :insertImageSettings="insertImageSettings" v-model="editData.description"></ejs-richtexteditor>
                  </v-flex>
                </v-layout>
              </v-container>
            </div>
          </v-flex>
        </v-layout>
        <v-layout>
          <v-flex xs12 class="button-container pr-3 text-xs-right">
            <div class="d-inline-flex" v-if="selectedData">
              <v-btn class="pf-btn pf-btn-cancel" @click="selectedData = false">
                <v-icon size="16" class="pr-1">cancel</v-icon>
                <div>Cancel</div>
              </v-btn>
              <v-btn class="pf-btn pf-btn-save" @click="save">
                <v-icon size="16" class="pr-1">check_circle</v-icon>
                <div>Save</div>
              </v-btn>
            </div>
          </v-flex>
        </v-layout>
      </v-container>
    </v-form>
  </div>
</template>

<script>
/* global session router store */
import swal from 'sweetalert2';
import { getCollection, update, remove, sortList, formatDate, updateSortList } from '../../helpers/helpers';
import { mapGetters } from 'vuex';
import draggable from 'vuedraggable';
import Vue from 'vue';
import { RichTextEditorPlugin, Toolbar, Image,  Link, HtmlEditor, QuickToolbar, NodeSelection } from '@syncfusion/ej2-vue-richtexteditor';

Vue.use(RichTextEditorPlugin);

import '@syncfusion/ej2-base/styles/material.css';
import '@syncfusion/ej2-inputs/styles/material.css';
import '@syncfusion/ej2-lists/styles/material.css';
import '@syncfusion/ej2-popups/styles/material.css';
import '@syncfusion/ej2-buttons/styles/material.css';
import '@syncfusion/ej2-navigations/styles/material.css';
import '@syncfusion/ej2-splitbuttons/styles/material.css';
import '@syncfusion/ej2-vue-richtexteditor/styles/material.css';

// This lists the FAQ items to the admin
export default {
  name: 'ListFAQAdmin',
  components: {
    draggable,
  },
  data: () => ({
    entity: 'Faq',
    selectedData: false,
    editIndex: -1,
    faq: {
      title: '',
      description: '',
      category: ''
    },
    membershipList: [
      'Network',
      'Featured',
      'Preferred'
    ],
    membershipRules: [
      v => v.length > 0 || 'membership is required'
    ],
    categoryList: [
      'Account',
      'Album',
      'Blog',
      'General',
      'Letter',
      'Profile Layout',
      'Video',
    ],
    rules: {
      required: v => !!v.trim() || 'Field is required.',
    },
    editData: {},
    content: '',
    ejsHeight: '400px', // editor data
    formRules: {
      title: [v => !!v || 'Description is required'],
    },
    insertImageSettings: {
      display: 'break',
      saveFormat: 'Base64'
    }
  }),
  provide: {
    richtexteditor: [Toolbar, Image, Link, HtmlEditor, QuickToolbar]
  },
  beforeRouteEnter (to, from, next) {
    if (!session.isOnline()) {
      next({ path: '/login' });
    } else {
      next();
    }
  },
  computed: {
    FAQList: {
      get () {
        return store.state.Faq;
      },
      set (value) {
        store.commit('setFaq', value);
      }
    }
  },
  created () {
    this.initialize();
  },
  methods: {
    // @vuese
    // Used to go back to the FAQ listing from edit mode
    backTolisting () {
      this.editIndex = -1;
      this.selectedData = false;
      window.getApp.$emit('pageSubHeader', '');
    },
    // @vuese
    // Used to fetch the FAQ list if not already exists
    async initialize () {
      if (!this.FAQList.length) {
        let sort = { 'createdAt': -1 };
        let { error, data } = await getCollection(this.entity, true, 0, '', {}, null, null, sort);
        if (error) {
          console.log(error);
        } else {
          if (data.length > 0) {
            this.FAQList = data;
          }
        }
      }
    },
    // @vuese
    // Used to setup the to edit the FAQ item
    // @arg The FAQ item object to be edited
    editItem (item) {
      window.getApp.$emit('pageSubHeader', 'Edit');
      this.editIndex = this.FAQList.indexOf(item);
      this.editData = Object.assign({}, item);
    },
    // @vuese
    // Used to show the form buttons
    changedData () {
      this.selectedData = true;
    },
    // @vuese
    // Used to hide the form buttons
    hideButtons () {
      this.selectedData = false;
    },
    // @vuese
    // Used to delete the FAQ item
    // @arg The FAQ item object to be deleted
    deleteItem (item) {
      swal.fire({
        title: 'Are you sure?',
        text: "You won't be able to revert this!",
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, delete it!'
      }).then((result) => {
        if (result.value) {
          (async () => {
            let { error, data, status } = await remove(this.entity, item.id);
            if (error) {
              console.log('error', error);
            } else {
              const index = this.FAQList.indexOf(item);
              this.FAQList.splice(index, 1);
              swal.fire(
                'Deleted!',
                'FAQ question "' + item.title + '" has been deleted.',
                'success'
              );
            }
          })();
        }
      });
    },
    // @vuese
    // Used to save the edited FAQ item
    async save () {
      if (!this.editData.description.replace(/(<([^>]+)>)/ig, '').replace(/\s/g, '').length) {
        swal.fire({
          type: 'warning',
          title: 'Content is required.',
          text: 'Please add content before saving!',
          showConfirmButton: true,
          confirmButtonColor: '#3085d6',
          confirmButtonText: 'OK'
        });
        return;
      }
      else {
        if (this.$refs.formEdit.validate() && this.editIndex > -1) {
          this.selectedData = false;
          let { error, data, status } = await update(this.entity, this.editData, this.editData.id);
          if (error) {
            this.selectedData = true;
            console.log('error', error);
          } else {
            this.FAQList[this.editIndex] = data;
            this.loading = false;
            swal.fire({
              type: 'success',
              title: 'FAQ updated successfully',
              showConfirmButton: false,
              timer: 2500,
              onClose: () => {
                this.editIndex = -1;
                window.getApp.$emit('pageSubHeader', '');
              }
            });
          }
        }
      }
    }
  }
};
</script>
<style scoped>

  #faq >>> .e-richtexteditor .e-rte-toolbar {
    z-index: auto !important;
  }

  #faq >>> .e-linkheader, #faq >>> .imgUrl {
  display: none !important;
}

</style>



// WEBPACK FOOTER //
// src/pages/FAQ/admin_list.vue